import * as AssetActions from "./assetActions";

export default AssetActions;
